import { render, staticRenderFns } from "./GodAdminToggle.vue?vue&type=template&id=0bc5d169&"
import script from "./GodAdminToggle.vue?vue&type=script&lang=js&"
export * from "./GodAdminToggle.vue?vue&type=script&lang=js&"
import style0 from "./GodAdminToggle.vue?vue&type=style&index=0&id=0bc5d169&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports